/**
 * Marine FSC (Federal Supply Class) taxonomy used to derive parts
 * categories client-side. The DW `/dwapi/ecommerce/groups` tree on this
 * hosted instance is a locked RV PIM hierarchy and is NOT rendered
 * anywhere as a category nav — we use these FSC entries instead.
 *
 * Every marine part's `shortDescription` includes a tag of the form
 * `FSC <code> | Cat <id>` (e.g. "FSC 2010 | Cat 6"), so a search by
 * the literal `FSC <code>` string filters cleanly to that category.
 */
export interface MarineCategory {
  /** FSC numeric code, e.g. "2010" */
  code: string;
  /** Display label */
  name: string;
  /** Short description for tiles */
  description?: string;
}

export const MARINE_CATEGORIES: MarineCategory[] = [
  { code: "1940", name: "Small Craft", description: "Tenders, dinghies, inflatables" },
  { code: "2010", name: "Propulsion Components", description: "Engines, drives, propellers" },
  { code: "2020", name: "Rigging", description: "Standing & running rigging, lines" },
  { code: "2030", name: "Deck Machinery", description: "Winches, windlasses, davits" },
  { code: "2040", name: "Hardware & Hull", description: "Cleats, fittings, hull hardware" },
  { code: "2050", name: "Marine Equipment", description: "Anchors, fenders, deck gear" },
  { code: "2090", name: "Misc. & Electronics", description: "Navigation, electronics, accessories" },
];

/** Build the search-results URL that lists products in a given FSC category. */
export function marineCategoryHref(code: string): string {
  return `/search-results?q=${encodeURIComponent("FSC " + code)}`;
}